
@if(datasource){
  <div class="list-cards__link-wrapper">
    <a 
      class="list-cards__link"
      (click)="goToSubCategoriesList(item.category)"
      [attr.aria-label]="'Ir a ' + item.category?.name?.[translate.currentLang]"
    >   
      <ci-icon 
        class="link__icon"
        type="svg" 
        [name]="item.category?.icon" 
        scale="1.5x"
      ></ci-icon>
      
      <div class="link__title-wrapper">
        <h3 class="link__title ci-heading-h3-bold">
          {{ item.category?.name?.[translate.currentLang] }}
        </h3>
      
        <ci-icon 
          class="link__arrow-icon"
          type="svg" 
          name="right" 
          scale="1x"
        ></ci-icon>
      </div>
    </a>
  </div>


  <div #eventContainer class="cardsScrollContainer items-scroll-wrapper">
      <ci-fab-button 
        #leftArrow 
        scrollControl
        class="item-arrow-left eventGoLeft"
        class-name="ci-btn-primary-outlined" 
        type="button" 
        icon-name="previous" 
        [attr.aria-label]="'Ir a la categoría anterior' | translate"
      ></ci-fab-button>
      
      <ci-fab-button 
        #rightArrow 
        scrollControl
        class="item-arrow-right eventGoRight"
        class-name="ci-btn-primary-outlined" 
        type="button" 
        icon-name="next" 
        [attr.aria-label]="'Ir a la categoría siguiente' | translate"
      ></ci-fab-button>
  
      <div class="viewport horizontal eventContainer" scrollControl>
          <div *uiScroll="let datasourceItem of datasource">
              <div class="item horizontal">
                @if(datasourceItem.type === 'item'){
                  <cicerone-generic-card 
                    [categoryNameSlug]="item.category?.nameSlug?.[translate.currentLang]"
                    [item]="datasourceItem.data" 
                    [defaultFileImgName]="getDefaultImgFileName(item.category?.nameSlug?.['es'], datasourceItem.data.id)"
                  />
                }
                @if(datasourceItem.type === 'more'){
                  <cicerone-generic-card 
                    (click)="goToSubCategoriesList(item.category)" 
                    [categoryNameSlug]="item.category?.nameSlug?.[translate.currentLang]"
                    [defaultFileImgName]="getDefaultImgFileName(item.category?.nameSlug?.['es'], datasourceItem.data.id)"
                    [seeMore]="true" 
                  />
                }                
              </div>
          </div>
      </div>
  </div>
}